import { render } from "./layout-change.vue?vue&type=template&id=d4f4f0c0&ts=true"
import script from "./layout-change.vue?vue&type=script&lang=ts"
export * from "./layout-change.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__